import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const highlights = [
    'Единые стандарты работы во всех подразделениях',
    'Быстрый ввод новичков без потери качества',
    'Развитие руководителей и кадрового резерва',
    'Накопление и передача внутренних знаний',
    'Масштабирование бизнеса без хаоса',
  ];

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-gray-900 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20digital%20corporate%20academy%20learning%20platform%20interface%20with%20holographic%20elements%2C%20clean%20minimalist%20design%2C%20dark%20background%20with%20teal%20and%20warm%20golden%20accents%2C%20sleek%20futuristic%20dashboard%20displaying%20learning%20paths%20and%20competency%20matrices%2C%20professional%20corporate%20aesthetic%2C%20abstract%20geometric%20patterns%2C%20soft%20glow%20effects%2C%20editorial%20quality&width=1600&height=900&seq=corp-academy-hero-01&orientation=landscape"
          alt="Корпоративная академия — цифровая платформа обучения"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/75 to-black/85"></div>
      </div>

      <div className="relative z-10 w-full px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <div>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6">
                Корпоративная академия
              </h1>
              <p className="text-base md:text-lg text-white/80 leading-relaxed mb-4 max-w-xl">
                Разовые тренинги дают краткосрочный эффект. Корпоративная академия создаёт систему, которая постоянно развивает сотрудников, руководителей и команду без хаоса и случайных решений.
              </p>
              <div className="space-y-2 mb-8">
                {highlights.map((h, i) => (
                  <div key={i} className="flex items-start gap-2 text-white/80 text-sm md:text-base">
                    <span className="text-teal-400 flex-shrink-0 mt-0.5">&#10003;</span>
                    <span>{h}</span>
                  </div>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={() => scrollTo('contact')} className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer">
                  Внедрить корпоративную академию
                </button>
                <LeadMagnetHeroTeaser />
              </div>

              <div className="mt-6 grid sm:grid-cols-2 gap-3 max-w-xl">
                <div className="bg-white/10 border border-white/20 rounded-lg p-4 backdrop-blur-sm">
                  <p className="text-xs font-semibold text-teal-300 uppercase tracking-wide mb-1">Для кого</p>
                  <p className="text-white/85 text-sm leading-relaxed">Компании, где несколько подразделений и нужны единые стандарты обучения и развития.</p>
                </div>
                <div className="bg-white/10 border border-white/20 rounded-lg p-4 backdrop-blur-sm">
                  <p className="text-xs font-semibold text-teal-300 uppercase tracking-wide mb-1">С чего начать</p>
                  <p className="text-white/85 text-sm leading-relaxed">С диагностики и пилотного модуля — затем масштабируем на всю компанию.</p>
                </div>
              </div>
            </div>


          </div>


        </div>
      </div>
    </section>
  );
}